import Provider from "../Provider";
import TypeOfFuelContextType from "./TypeOfFuelContextType";

export default interface TypeOfFuelProvider extends Provider<TypeOfFuelContextType> {
    
}

export const TypeOfFuelProviderName = "TypeOfFuelProvider";